import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import { formatLtPlusMonthlyPrice } from '../../util/landtrustPlus';
import { propTypes } from '../../util/types';

import glpCss from '../LineItemGuestLiabilityProtection/LineItemGuestLiabilityProtection.module.css';

const LineItemLtPlusMembership = props => {
  const { transaction, isCustomer, intl } = props;

  if (!isCustomer) {
    return null;
  }

  const currency = transaction?.attributes?.payinTotal?.currency || 'USD';
  const formattedMembershipPrice = formatLtPlusMonthlyPrice(intl, currency);

  return (
    <div className={glpCss.lineItem}>
      <span className={glpCss.itemLabel}>
        <FormattedMessage id="BookingBreakdown.landtrustPlusMembership" />
      </span>
      <span className={glpCss.itemValue}>
        <FormattedMessage
          id="BookingBreakdown.landtrustPlusMembershipMonthly"
          values={{ price: formattedMembershipPrice }}
        />
      </span>
    </div>
  );
};

LineItemLtPlusMembership.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isCustomer: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemLtPlusMembership;
